import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxTextBoxModule, DxValidatorModule, DxCheckBoxModule, DxPopoverModule } from 'devextreme-angular';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { SvgIconComponent } from '../../../../../../../../components/svg-icon/svg-icon.component';
import { ProjectConfigNodeComponent } from '../../project-config-node.component';
import { Phase } from '../../../../../../../../interfaces/entities/project-configuration';

@Component({
    selector: 'app-phase-project-config-node',
    imports: [
        CommonModule,
        FormsModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxiValidationRuleModule,
        DxCheckBoxModule,
        DxPopoverModule,
        SvgIconComponent,
        ProjectConfigNodeComponent,
    ],
    templateUrl: './phase-project-config-node.component.html',
    styleUrl: './phase-project-config-node.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhaseProjectConfigNodeComponent {
  readonly messageShowInGantt = $localize`:@@showInGantt:Show in Gantt`;

  @Input() phase!: Phase;
  @Input() phases!: Phase[];
  @Input() itemNumber!: number;
  @Input() isEditing: boolean = false;
  @Input() isNew: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() validationCallback?: (value: string) => boolean;

  @Output() onSave = new EventEmitter<Phase>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onStartEdit = new EventEmitter<Phase>();
  @Output() onPhaseClick = new EventEmitter<void>();
  @Output() hovering = new EventEmitter<boolean>();

  editingPhase: Phase | null = null;

  ngOnInit() {
    this.editingPhase = { ...this.phase };
  }
  // Custom save handler to emit the current phase name
  handleSave() {
    this.onSave.emit(this.editingPhase!);
  }

  // Unique name validation for phases
  uniqueNameValidationCallback = (params: any): boolean => {
    const currentName = params?.value || params?.data || params;

    if (!currentName || currentName.trim() === '') {
      return true; // Let required validation handle empty values
    }

    // Check if any other phase has the same name (case-insensitive)
    const duplicateExists = this.phases.some(otherPhase => {
      if (otherPhase.id === this.editingPhase.id) {
        return false; // Skip current phase
      }

      return otherPhase.title && otherPhase.title.trim().toLowerCase() === currentName.trim().toLowerCase();
    });

    return !duplicateExists;
  };

  onItemClick() {
    if (!this.isEditing) {
      this.onPhaseClick.emit();
    }
  }

  onEditing() {
    this.editingPhase = { ...this.phase };
    this.onStartEdit.emit(this.editingPhase!);
  }
}
